module.exports = __webpack_public_path__ + "img/gs.gse6ba1f5.svg";